<template>
  <div class="row item">
    <div class="col">
      <h5 class="title">
        <span class="category">{{ item.category }}</span> | {{ item.name }}
      </h5>
      <div class="row">
        <div class="col-6">
          <div><img v-if="item.contentType === 'image'" :src="item.contentURL" /></div>
          <div>Online: {{ item.contentURL }}</div>
        </div>
        <div class="col-6">
          <img v-if="item.contentType === 'image'" :src="imageUrl" />
          <div>Local: {{ imageUrl }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div><a @click.prevent.stop="showRawJson = !showRawJson" href="#">*</a></div>
          <pre v-if="showRawJson">{{ item }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { nextTick } from 'vue'

export default {
  name: 'ZeroxaEvent',
  components: {},
  props: {
    item: Object
  },
  data () {
    return {
      showRawJson: false
    }
  },
  computed: {
    imageUrl () {
      // return `http://localhost:3331/image?url=${encodeURIComponent(this.item.contentURL)}&format=square300`
      return `http://localhost:3331/image?url=${encodeURI(this.item.contentURL)}&format=square300`
    }
  },
  methods: {
  }

}
</script>
